import axios from '../utils/axios';

export default function fetchPotentialPaidJobAssginees(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/potential-paid-jobs-assignees', {
            params: params
        })
    )
}
